import { Injectable } from '@nestjs/common';
import { RmZones } from '../rm-zones.entity';
import { RmZonesDTO } from './rm-zone.dto';

@Injectable()
export class RmZoneAdapter {
  /**
   *
   * @param rmZonesDTO
   * @returns Zone entity
   */
  public convertDtoToEntity(  rmZonesDTO: RmZonesDTO,  isUpdate: boolean = false ): RmZones {
    const zone = new RmZones();
    zone.rmZoneId=rmZonesDTO.rmZoneId;
    zone.rmZoneCode=rmZonesDTO.rmZoneCode;
    zone.rmZoneName=rmZonesDTO.rmZoneName;
    zone.plantId=rmZonesDTO.plantId;
    zone.isActive=rmZonesDTO.isActive==undefined?true:rmZonesDTO.isActive;
    if (isUpdate) {
      zone.updatedUser = rmZonesDTO.updatedUser;
    } else {
      zone.isActive = true;
      zone.createdUser = rmZonesDTO.createdUser;
    }
   return zone;
  }
  public convertEntityToDto(zoneObject: RmZones): RmZonesDTO {
    const rmZonesDTO= new RmZonesDTO;
    rmZonesDTO.rmZoneId = zoneObject.rmZoneId;
    rmZonesDTO.rmZoneCode = zoneObject.rmZoneCode;
    rmZonesDTO.rmZoneName = zoneObject.rmZoneName;
    rmZonesDTO.plantId = zoneObject.plantId;
    rmZonesDTO.isActive = zoneObject.isActive;
    rmZonesDTO.createdAt = zoneObject.createdAt;
    rmZonesDTO.updatedAt = zoneObject.updatedAt;
    rmZonesDTO.createdUser = zoneObject.createdUser;
    rmZonesDTO.updatedUser = zoneObject.updatedUser;
    rmZonesDTO.versionFlag = zoneObject.versionFlag;
    return rmZonesDTO;
  }
}
